import { render } from "./InvestmentTable.vue?vue&type=template&id=a7614ab8&scoped=true"
import script from "./InvestmentTable.vue?vue&type=script&lang=js"
export * from "./InvestmentTable.vue?vue&type=script&lang=js"

import "./InvestmentTable.vue?vue&type=style&index=0&id=a7614ab8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7614ab8"]])

export default __exports__